import { useMemo } from 'react';
import * as R from 'remeda';
import { Skeleton } from '@rossum/ui/material';
import { Tile } from './Tile';
import { TileChip } from './types';

type TileSkeletonPart = 'icon' | 'title' | 'description' | 'endChips';

type TileSkeletonProps = {
  skeletons?: TileSkeletonPart[];
  hasTo?: boolean;
  hasContextMenu?: boolean;
};

const TITLE_MIN_WIDTH = 120;
const TITLE_MAX_WIDTH = 180;
const DESCRIPTION_MIN_WIDTH = 80;
const DESCRIPTION_MAX_WIDTH = 140;

const SKELETON_END_CHIPS: TileChip[] = [
  { key: 'skeleton-a', label: '', isLoading: true },
  { key: 'skeleton-b', label: '', isLoading: true },
  { key: 'skeleton-c', label: '', isLoading: true },
];

export const TileSkeleton = ({
  skeletons = [],
  hasTo,
  hasContextMenu,
}: TileSkeletonProps) => {
  const titleWidth = useMemo(
    () => R.randomInteger(TITLE_MIN_WIDTH, TITLE_MAX_WIDTH),
    []
  );
  const descriptionWidth = useMemo(
    () => R.randomInteger(DESCRIPTION_MIN_WIDTH, DESCRIPTION_MAX_WIDTH),
    []
  );

  const hasIcon = skeletons.includes('icon');
  const hasTitle = skeletons.includes('title');
  const hasDescription = skeletons.includes('description');
  const hasEndChips = skeletons.includes('endChips');

  return (
    <Tile
      iconProps={hasIcon ? { skeleton: true } : undefined}
      title={
        hasTitle ? <Skeleton variant="text" width={titleWidth} /> : <span />
      }
      description={
        hasDescription ? (
          <Skeleton variant="text" width={descriptionWidth} />
        ) : undefined
      }
      endChips={hasEndChips ? SKELETON_END_CHIPS : undefined}
      contextMenuItems={hasContextMenu ? [] : undefined}
      to={hasTo ? '#' : undefined}
      dragHandle={null}
    />
  );
};
